<script>
  // ── Bestand richtigstellen (A7/US-4, L8) ─────────────────────────────────
  //
  // Konzept: Konzepte/Lager/us4-bestand-richtigstellen.md, Abschnitte 4 und 7.
  //
  // ⚠ AUCH DIESES BAUTEIL HAT KEINE KIT-VORLAGE.
  // Der Entwurf zeichnet einen Knopf „Bestand korrigieren" unter dem CTA des
  // Zutat-Details — und sonst nichts: keine Maske, keine Zustände, keine
  // Meldung. Das hier ist Entwurf, nicht Nachbau.
  //
  // WARUM EINE EIGENE KOMPONENTE UND KEIN AUSBAU VON BuchungSheet.svelte
  // Das eine zeigt eine VORHANDENE Buchung und nimmt sie zurück; dieses legt
  // eine NEUE an. Gemeinsam ist die Hülle, nicht der Inhalt — und eine Hülle
  // ist in Svelte ein paar Zeilen CSS, ein geteilter Zustand wäre eine
  // Verzweigung in jeder zweiten Zeile.
  //
  // ZWEI FRAGEN, EIN ORT
  // „Gewogen" (absolut → `inventur`) und „Abgang" (relativ → `abgang`) stehen
  // hinter EINEM Einstieg. Wer „stimmt nicht, ich weiß nicht warum" denkt,
  // kann eine Vorabfrage nach dem richtigen Weg nicht beantworten; innen, mit
  // der Zahl daneben, ist sie leicht.
  //
  // Die beiden hießen bis zum ersten Prüfblatt „Gezählt" und „Weggegangen".
  // Umgangssprachlich — und im Lager wird gewogen, nicht gezählt (2026-09-10).
  //
  // WAS HIER NICHT HINGEHÖRT — und wohin es gehört
  // Eine Fehlbuchung (Vertipper, doppelt gebucht) wird NICHT korrigiert,
  // sondern im Verlauf zurückgenommen. Sonst stehen zwei Buchungen im Journal,
  // die beide falsch erzählen, was passiert ist. Der Hinweis unten im Sheet
  // ist deshalb Teil der Funktion, nicht Beiwerk.
  import { tick } from 'svelte';

  /** @type {{ zutatId: string, onschliessen: () => void }} */
  let { zutatId, onschliessen } = $props();

  const t = (k, p) => window.t(k, p);

  const EINHEITEN = ['kg', 'g'];

  // Die Chips sind Eingabehilfe, keine Taxonomie: Sie füllen dasselbe Feld,
  // das man auch selbst beschreiben kann. Es gibt keine Auswertung über sie —
  // und solange es keine gibt, wird der Text nicht normiert.
  // „Verderb" und „MHD" standen bis zum zweiten Pruefblatt einzeln — im
  // Regal ist das dieselbe Entscheidung (2026-09-15). Dafuer kam ASG dazu:
  // Anstellgut zehrt vom Mehlbestand, ohne je auf einem Backtag zu stehen,
  // und war bis dahin ein Fall fuer „Sonstiges".
  const GRUENDE = {
    zaehlen: ['verzaehlt', 'unerfasst', 'verderb', 'sonstiges'],
    abgang:  ['verderb_mhd', 'verschuettet', 'asg', 'sonstiges'],
  };

  let modus   = $state(/** @type {'zaehlen'|'abgang'} */ ('zaehlen'));
  let wert    = $state('');
  let einheit = $state('kg');
  let grund   = $state('');
  let laeuft  = $state(false);
  let veraltet = $state(false);
  let feldEl;
  let grundEl;

  // Handgelegte Abhängigkeit: Sie ist der einzige Weg, `pruefung` neu rechnen
  // zu lassen, ohne dass die Eingabe sich geändert hat — s. buchen().
  let takt = $state(0);

  /** Eingabe in Gramm, oder null, solange nichts Brauchbares dasteht. */
  let gramm = $derived.by(() => {
    const roh = String(wert).replace(',', '.').trim();
    if (!roh) return null;
    const n = parseFloat(roh);
    if (!Number.isFinite(n)) return null;
    return Math.round(einheit === 'kg' ? n * 1000 : n);
  });

  // ⚠ DIE VORSCHAU IST BEWUSST NICHT LIVE.
  // `lagerZaehlDifferenz()` liest den Bestand bei jedem Aufruf frisch, diese
  // Ableitung rechnet aber nur, wenn die EINGABE sich ändert — das Journal ist
  // keine Abhängigkeit. Genau das ist gewollt (Konzept 4.7): Eine Zahl, die
  // sich unter der Hand ändert, während jemand sie liest, ist schlimmer als
  // eine, die einen Moment alt ist. Gebucht wird trotzdem nie eine veraltete
  // Differenz — buchen() rechnet noch einmal und fragt nach.
  let pruefung = $derived.by(() => {
    takt;
    return rechne();
  });

  let zutat      = $derived(window.zutatById?.(zutatId));
  let bestand    = $derived(window.lagerMenge(pruefung.bestand));
  let grundFehlt = $derived(modus === 'abgang' && !grund.trim());
  let bereit     = $derived(pruefung.buchbar && !grundFehlt && !laeuft);

  function rechne() {
    if (gramm == null) {
      return { bestand: window.lagerBestandFuer(zutatId), differenz: 0, buchbar: false, hinweis: null };
    }
    return modus === 'zaehlen'
      ? window.lagerZaehlDifferenz(zutatId, gramm)
      : window.lagerAbgangDifferenz(zutatId, gramm);
  }

  function delta(g) {
    const m = window.lagerMenge(Math.abs(g));
    return `${g < 0 ? '−' : '+'}${m.wert} ${m.einheit}`;
  }

  function menge(g) {
    const m = window.lagerMenge(g);
    return `${m.wert} ${m.einheit}`;
  }

  async function wechsle(m) {
    if (m === modus) return;
    modus = m;
    // Die Zahl bedeutet im anderen Modus etwas anderes — „12,4" als Zählung
    // ist ein voller Sack, als Abgang ein weggeworfener. Stehen bleiben darf
    // sie deshalb nicht.
    wert = '';
    grund = '';
    veraltet = false;
    await tick();
    feldEl?.focus();
  }

  function einheitWechseln() {
    einheit = EINHEITEN[(EINHEITEN.indexOf(einheit) + 1) % EINHEITEN.length];
  }

  async function chip(schluessel) {
    // „Sonstiges" ist kein Grund, sondern die Ansage, selbst einen zu
    // schreiben. Also traegt es sich NICHT ins Feld ein — sonst muesste man
    // das Wort erst wieder loeschen, um den eigentlichen Grund zu tippen —,
    // sondern raeumt es und setzt den Cursor hinein (Pruefblatt 2026-09-15).
    if (schluessel === 'sonstiges') {
      grund = '';
      await tick();
      grundEl?.focus();
      return;
    }
    const text = t(`lager_korr_grund_${schluessel}`);
    grund = grund === text ? '' : text;
  }

  async function buchen() {
    if (!bereit) return;

    // Zwischen Öffnen und Klick kann ein Cloud-Pull, ein zweites Gerät oder ein
    // Backtag-Abschluss den Ausgangswert verschoben haben. Dann wird nicht
    // gebucht, sondern gezeigt — und erst der zweite Klick bucht.
    const frisch = rechne();
    if (frisch.bestand !== pruefung.bestand) {
      veraltet = true;
      takt += 1;
      return;
    }
    if (!frisch.buchbar) return;

    laeuft = true;
    try {
      const zaehlung = modus === 'zaehlen';
      const b = await window.lagerBuchen(zaehlung
        ? { zutatId, menge: frisch.differenz, art: 'inventur',
            gezaehlt: gramm, notiz: grund.trim() || null }
        : { zutatId, menge: frisch.differenz, art: 'abgang', notiz: grund.trim() });

      if (!b) {
        // lager-journal.js schreibt den Grund in die Konsole — der Nutzer sieht
        // sie nicht, und ein Knopf, der nichts sagt, sieht aus wie einer, der
        // nichts tut.
        window.notify?.({ level: 'err', text: t('lager_korr_fehler') });
        return;
      }

      // Die Meldung nennt den STAND, nicht die Differenz: Die Differenz stand
      // eben noch in der Maske, der neue Bestand ist das Ergebnis.
      window.notify?.({
        level: 'ok',
        text: t(zaehlung ? 'lager_korr_gebucht_zaehlen' : 'lager_korr_gebucht_abgang',
                { menge: menge(window.lagerBestandFuer(zutatId)) }),
        cta: {
          // Kurzlebig wie bei der Lieferung (L3): Der dauerhafte Weg zurück ist
          // die Zeile im Verlauf, und dort steht sie ab jetzt.
          label: t('lager_gebucht_rueckgaengig'),
          onClick: async () => {
            const ok = await window.lagerStornieren(b.id);
            window.notify?.({ level: ok ? 'info' : 'err',
                              text: t(ok ? 'lager_storniert' : 'lager_korr_fehler') });
          },
        },
      });
      onschliessen();
    } finally {
      laeuft = false;
    }
  }
</script>

<!-- Escape schließt, Cmd/Strg+Enter bucht — dieselben Griffe wie in der
     Eingangsmaske. Am FENSTER, damit sie auch greifen, wenn der Fokus gerade
     nirgends sitzt. -->
<svelte:window onkeydown={(e) => {
  if (e.key === 'Escape') { onschliessen(); return; }
  if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); buchen(); }
}} />

<div class="lg-host">
  <div class="lg-scrim" onclick={onschliessen} role="presentation"></div>

  <!-- Der Dialog ist der Kasten, das Formular liegt darin: Ein <form> ist kein
       bedienbares Element und darf die Rolle „dialog" nicht tragen (Svelte
       a11y). `display: contents` hält das Formular trotzdem aus dem Layout
       heraus — Kopf, Leib und Fuß bleiben die Flex-Kinder des Kastens. -->
  <div class="lg-sheet" role="dialog" aria-modal="true" aria-label={t('lager_korr_titel')}>
  <form class="lg-korr__form" onsubmit={(e) => { e.preventDefault(); buchen(); }}>
    <div class="lg-sheet__head">
      <div class="lg-sheet__kopftext">
        <div class="lg-sheet__titel">{t('lager_korr_titel')}</div>
        <div class="lg-sheet__unter">{zutat?.name || ''}</div>
      </div>
      <button type="button" class="lg-sheet__x" onclick={onschliessen}
              aria-label={t('lager_korr_schliessen')}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"
             stroke-linecap="round" width="19" height="19" aria-hidden="true">
          <line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="lg-korr__leib">
      <!-- Der Umschalter benennt die beiden HANDLUNGEN. „Inventur" bleibt
           draußen — das ist das Wort der Buchhaltung, gewogen wird an der
           Waage. „Abgang" dagegen sagt in der Backstube dasselbe wie im
           Journal und darf deshalb stehen. -->
      <div class="lg-schalter" role="group" aria-label={t('lager_korr_titel')}>
        <button type="button" class="lg-schalter__t" class:is-an={modus === 'zaehlen'}
                aria-pressed={modus === 'zaehlen'} onclick={() => wechsle('zaehlen')}>
          {t('lager_korr_modus_zaehlen')}
        </button>
        <button type="button" class="lg-schalter__t" class:is-an={modus === 'abgang'}
                aria-pressed={modus === 'abgang'} onclick={() => wechsle('abgang')}>
          {t('lager_korr_modus_abgang')}
        </button>
      </div>

      <div class="lg-korr__ist">
        <span>{t('lager_korr_ist')}</span>
        <b>{bestand.wert} {bestand.einheit}</b>
      </div>

      <label class="lg-korr__feld">
        <span class="lg-lab">
          {t(modus === 'zaehlen' ? 'lager_korr_gezaehlt_label' : 'lager_korr_menge_label')}
        </span>
        <span class="lg-korr__zeile">
          <!-- `inputmode="decimal"`: In der Backstube steht ein Handy in der
               Hand, und dort ist die Zehnertastatur der Unterschied zwischen
               zwei und sechs Griffen. -->
          <input class="lg-korr__zahl" type="text" inputmode="decimal" bind:value={wert}
                 bind:this={feldEl} onfocus={() => (veraltet = false)}
                 placeholder="0" autocomplete="off">
          <button type="button" class="lg-korr__einheit" onclick={einheitWechseln}
                  aria-label={t('lager_einheit_wechseln')}>{einheit}</button>
        </span>
      </label>

      {#if pruefung.buchbar}
        <p class="lg-korr__vorschau">
          {t(modus === 'zaehlen' ? 'lager_korr_vorschau_zaehlen' : 'lager_korr_vorschau_abgang',
             { delta: delta(pruefung.differenz) })}
        </p>
      {/if}

      {#if veraltet}
        <p class="lg-korr__warn">
          {t('lager_korr_veraltet', { menge: menge(pruefung.bestand),
                                      delta: delta(pruefung.differenz) })}
        </p>
      {:else if pruefung.hinweis}
        <p class="lg-korr__hinweis">{pruefung.hinweis}</p>
      {/if}

      <div class="lg-korr__grund">
        <span class="lg-lab">
          {t(modus === 'abgang' ? 'lager_korr_grund_pflicht' : 'lager_korr_grund_freiwillig')}
        </span>
        <div class="lg-korr__chips">
          {#each GRUENDE[modus] as g (g)}
            <button type="button" class="lg-chip"
                    class:is-an={grund === t(`lager_korr_grund_${g}`)}
                    onclick={() => chip(g)}>{t(`lager_korr_grund_${g}`)}</button>
          {/each}
        </div>
        <input class="lg-box" type="text" bind:value={grund} bind:this={grundEl}
               placeholder={t('lager_korr_grund_ph')} autocomplete="off">
      </div>
    </div>

    <div class="lg-sheet__fuss">
      <!-- Der Weg, den diese Maske NICHT ist. Er steht hier unten und nicht
           oben: Wer schon getippt hat, soll ihn finden, ohne dass er jedem im
           Weg steht, der zu Recht hier ist. -->
      <p class="lg-korr__note">{t('lager_korr_fehlbuchung')}</p>
      {#if grundFehlt && gramm != null}
        <p class="lg-korr__hinweis">{t('lager_korr_grund_fehlt')}</p>
      {/if}
      <button type="submit" class="lg-haupt lg-haupt--breit" disabled={!bereit}>
        {t(veraltet ? 'lager_korr_bestaetigen' : 'lager_korr_buchen')}
      </button>
    </div>
  </form>
  </div>
</div>

<style>
  /* Dieselbe Hülle wie Eingangsmaske und Buchungs-Sheet: schmal eine Fläche am
     unteren Rand, ab 600 px ein Dialog über der Ansicht. */
  .lg-host { position: fixed; inset: 0; z-index: 60; display: flex; container-type: inline-size; }
  .lg-scrim { position: absolute; inset: 0; background: rgba(41, 37, 36, 0.30); }

  .lg-sheet {
    position: relative;
    margin-top: auto;
    width: 100%;
    max-height: 92vh;
    display: flex;
    flex-direction: column;
    background: var(--lg-card);
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -12px 40px -18px rgba(28, 25, 23, 0.45);
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }

  .lg-sheet__head {
    display: grid; grid-template-columns: 1fr 44px; align-items: center;
    gap: 8px; padding: 14px 10px 10px 20px;
    border-bottom: 1px solid var(--lg-line-fein);
  }
  .lg-sheet__kopftext { min-width: 0; }
  .lg-sheet__titel {
    font-size: 16px; font-weight: 700; color: var(--lg-ink); letter-spacing: -0.015em;
  }
  .lg-sheet__unter {
    margin-top: 2px;
    font-size: 12px; color: var(--lg-ink-mute);
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  }
  .lg-sheet__x {
    width: 44px; height: 44px; display: flex; align-items: center; justify-content: center;
    border: 0; border-radius: 10px; background: none; color: var(--lg-ink-soft); cursor: pointer;
  }
  .lg-sheet__x:hover { background: rgba(41, 37, 36, 0.06); color: var(--lg-ink); }
  .lg-sheet__x:focus-visible { outline: 2px solid var(--lg-ink); outline-offset: -2px; }

  /* Der Leib scrollt, Kopf und Fuß bleiben stehen: Auf 390 px mit offener
     Tastatur ist der Knopf sonst weg. */
  .lg-korr__form { display: contents; }
  .lg-korr__leib { flex: 1 1 auto; min-height: 0; overflow-y: auto; padding: 14px 20px 4px; }

  .lg-schalter {
    display: grid; grid-template-columns: 1fr 1fr; gap: 4px;
    padding: 4px; border-radius: 12px; background: var(--lg-tint);
    border: 1px solid var(--lg-line);
  }
  .lg-schalter__t {
    min-height: 40px; border: 0; border-radius: 9px; background: none;
    font: inherit; font-size: 13.5px; font-weight: 700; color: var(--lg-ink-mittel);
    cursor: pointer;
  }
  .lg-schalter__t.is-an { background: var(--lg-card); color: var(--lg-ink); box-shadow: 0 1px 3px rgba(28, 25, 23, 0.10); }
  .lg-schalter__t:focus-visible { outline: 2px solid var(--lg-ink); outline-offset: -2px; }

  .lg-korr__ist {
    display: flex; align-items: baseline; justify-content: space-between; gap: 16px;
    padding: 14px 0 12px;
    font-size: 12px; color: var(--lg-ink-mute);
  }
  .lg-korr__ist b {
    font-size: 15px; font-weight: 700; color: var(--lg-ink);
    font-variant-numeric: tabular-nums;
  }

  .lg-korr__feld { display: block; }
  .lg-lab {
    display: block; font-size: 11px; font-weight: 700; letter-spacing: 0.07em;
    text-transform: uppercase; color: var(--lg-ink-mute); margin-bottom: 8px;
  }
  /* Vier Stellen brauchen keine halbe Sheet-Breite. Ein Feld, das viel
     größer ist als das, was hineinsoll, sieht aus, als erwarte es mehr —
     und lässt den Rest der Zeile leer wirken (Prüfblatt 2026-09-10). */
  .lg-korr__zeile {
    display: grid; grid-template-columns: 132px 56px; gap: 6px;
    justify-content: start;
  }
  .lg-korr__zahl {
    height: 52px; box-sizing: border-box; padding: 0 12px; min-width: 0;
    background: var(--lg-card); border: 1px solid #d6d3d1; border-radius: 10px;
    font: inherit; font-size: 20px; font-weight: 700; color: var(--lg-ink);
    font-variant-numeric: tabular-nums;
  }
  .lg-korr__zahl:focus { outline: none; border-color: var(--lg-ink); box-shadow: 0 0 0 3px rgba(41, 37, 36, 0.07); }
  /* Gepunktet unterstrichen: Ohne Rahmen und ohne Flaeche sah „kg" aus wie
     eine Beschriftung, und wer 500 g buchen wollte, tippte 0,5 (Pruefblatt
     2026-09-15). Die Punktlinie ist das leiseste Zeichen, das „hier laesst
     sich etwas umstellen" sagt — ein zweiter Rahmen neben dem Zahlenfeld
     waere ein zweites Eingabefeld, das es nicht ist. */
  .lg-korr__einheit {
    height: 52px; border: 0; border-radius: 10px; background: none; font: inherit;
    font-size: 13px; font-weight: 700; color: var(--lg-ink-soft); cursor: pointer;
    text-decoration: underline dotted;
    text-decoration-color: var(--lg-ink-mute);
    text-underline-offset: 4px;
  }
  .lg-korr__einheit:hover { background: rgba(41, 37, 36, 0.06); color: var(--lg-ink); }
  .lg-korr__einheit:focus-visible { outline: 2px solid var(--lg-ink); outline-offset: -2px; }

  .lg-korr__vorschau {
    margin: 10px 0 0;
    font-size: 13.5px; font-weight: 600; color: var(--lg-ink);
  }
  .lg-korr__hinweis {
    margin: 10px 0 0;
    font-size: 12.5px; line-height: 1.5; color: var(--lg-ink-soft);
  }
  /* Die einzige Farbe in dieser Maske, die eine AUSSAGE trägt — dieselbe wie
     die Fehlmenge, aus demselben Satz Tokens (--attention-*). */
  .lg-korr__warn {
    margin: 10px 0 0; padding: 10px 12px;
    background: var(--lg-fehlt-bg); border: 1px solid var(--lg-fehlt-edge); border-radius: 10px;
    font-size: 12.5px; line-height: 1.5; color: var(--lg-fehlt-ink);
  }

  .lg-korr__grund { margin-top: 18px; }
  .lg-korr__chips { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 8px; }
  .lg-chip {
    min-height: 34px; padding: 0 12px; border-radius: 999px;
    border: 1px solid var(--lg-line); background: var(--lg-card);
    font: inherit; font-size: 12.5px; font-weight: 600; color: var(--lg-ink-mittel);
    cursor: pointer;
  }
  .lg-chip:hover { border-color: var(--lg-ink-mute); color: var(--lg-ink); }
  /* Gefüllt, aber nicht schwarz: Ein Chip ist eine Auswahl, keine Handlung —
     Tinte auf Weiß ist der Kontrast, den in diesem Modul der CTA trägt. Die
     Stufe darunter (stone-200 auf stone-400) unterscheidet gewählt von nicht
     gewählt genauso eindeutig, ohne die Reihe zu dominieren. */
  .lg-chip.is-an {
    background: var(--lg-line); border-color: var(--lg-ink-mute);
    color: var(--lg-ink); font-weight: 700;
  }
  .lg-chip:focus-visible { outline: 2px solid var(--lg-ink); outline-offset: 2px; }

  .lg-box {
    display: block; width: 100%; box-sizing: border-box; min-height: 44px; padding: 0 10px;
    background: var(--lg-card); border: 1px solid #d6d3d1; border-radius: 10px;
    font: inherit; font-size: 13.5px; color: var(--lg-ink);
  }
  .lg-box:focus { outline: none; border-color: var(--lg-ink); box-shadow: 0 0 0 3px rgba(41, 37, 36, 0.07); }

  .lg-sheet__fuss {
    padding: 12px 20px 20px;
    border-top: 1px solid var(--lg-line-fein);
    background: var(--lg-card);
  }
  .lg-korr__note {
    margin: 0 0 12px;
    font-size: 11.5px; line-height: 1.5; color: var(--lg-ink-mute);
  }

  .lg-haupt {
    display: inline-flex; align-items: center; justify-content: center; gap: 8px;
    min-height: 48px; padding: 0 18px; border: 0; border-radius: 10px;
    background: var(--lg-accent); color: #fff; font: inherit;
    font-size: 15px; font-weight: 700; letter-spacing: -0.01em; cursor: pointer;
    box-shadow: 0 6px 16px -8px rgba(192, 90, 62, 0.5);
  }
  .lg-haupt--breit { width: 100%; }
  .lg-haupt:hover:not(:disabled) { background: var(--lg-accent-hover); }
  .lg-haupt:focus-visible { outline: 2px solid var(--lg-ink); outline-offset: 2px; }
  .lg-haupt:disabled { opacity: 0.45; cursor: default; box-shadow: none; }

  @container (min-width: 600px) {
    .lg-sheet {
      margin: auto;
      width: 460px;
      max-height: 88vh;
      border-radius: 14px;
      border: 1px solid var(--lg-line);
      box-shadow: 0 24px 48px -24px rgba(28, 25, 23, 0.45);
    }
  }
</style>
